import { render, staticRenderFns } from "./ExpiryDialog.vue?vue&type=template&id=63c7936c"
import script from "./ExpiryDialog.vue?vue&type=script&lang=ts"
export * from "./ExpiryDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports